import {REPORT_ALL_ORGANIZATION_ORDERS} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_ORGANIZATION_ORDERS,
};
